import { gql } from 'apollo-boost';

export default gql`
    mutation Logout($input: Act) {
        userlogout(input: $input) {
            message
        }
    }
`;
